const Joi = require("joi");
const ValidationTranslateFile = require("../../src/config/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const myAccountSchema = Joi.object({
  userName: Joi.string().trim().alphanum().min(3).max(50).required().messages({
    "string.base": currentLang?.ValidationSchema?.User_Name_must_be_a_string,
    "string.alphanum": currentLang?.ValidationSchema?.User_Name_must_alphanumeric_characters,
    "string.min": currentLang?.ValidationSchema?.Minimum_3_characters,
    "string.max": "User Name must be at most {#limit} characters long.",
    "any.required": currentLang?.ValidationSchema?.Please_enter_Username,
    "string.empty": currentLang?.ValidationSchema?.Please_enter_Username,
  }),

  email: Joi.string()
    .trim()
    .pattern(
      new RegExp(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
      )
    )
    .required()
    .messages({
      "string.pattern.base": currentLang?.ValidationSchema?.Please_enter_valid_email,
      "any.required": currentLang?.ValidationSchema?.Please_enter_email,
      "string.empty": currentLang?.ValidationSchema?.Please_enter_email,
    }),

  confirmEmail: Joi.string().valid(Joi.ref("email")).required().messages({
    "any.only": currentLang?.ValidationSchema?.Email_And_ConfirmEmail_MustMatch,
    "any.required": currentLang?.ValidationSchema?.Please_enter_confirm_email,
    "string.empty": currentLang?.ValidationSchema?.Please_enter_confirm_email,
  }),

  userPassword: Joi.string()
    .pattern(
      new RegExp(
        /^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()\[\]-]{8,50}$/
      )
    )
    .required()
    .messages({
      "string.pattern.base": currentLang?.ValidationSchema?.Password_Minimum_8_Characters,
      "any.required": currentLang?.ValidationSchema?.Please_enter_password,
      "string.empty": currentLang?.ValidationSchema?.Please_enter_password,
    }),

  confirmPassword: Joi.string()
    .valid(Joi.ref("userPassword"))
    .required()
    .messages({
      "any.only": currentLang?.ValidationSchema?.Pwd_And_ConfirmPwd_MustMatch,
      "any.required": currentLang?.ValidationSchema?.Please_enter_confirm_password,
      "string.empty": currentLang?.ValidationSchema?.Please_enter_confirm_password,
    }),

  firstName: Joi.string()
    .trim()
    .pattern(/^[A-Za-z0-9]+$/)
    .min(3)
    .max(50)
    .required()
    .messages({
      "string.base": currentLang?.ValidationSchema?.FirstName_must_string,
      "string.pattern.base": currentLang?.ValidationSchema?.FirstName_must_alphanumeric_characters,
      "string.min": currentLang?.ValidationSchema?.Minimum_3_characters,
      "string.max": "First Name must be at most {#limit} characters long.",
      "any.required": currentLang?.ValidationSchema?.Please_enter_firstname,
      "string.empty": currentLang?.ValidationSchema?.Please_enter_firstname,
    }),

  lastName: Joi.string()
    .trim()
    .pattern(/^[A-Za-z0-9]+$/)
    .min(3)
    .max(50)
    .required()
    .messages({
      "string.base": currentLang?.ValidationSchema?.LastName_must_string,
      "string.pattern.base": currentLang?.ValidationSchema?.LastName_must_alphanumeric_characters,
      "string.min": currentLang?.ValidationSchema?.Minimum_3_characters,
      "string.max": "Last Name must be at most {#limit} characters long.",
      "any.required": currentLang?.ValidationSchema?.Please_enter_last_name,
      "string.empty": currentLang?.ValidationSchema?.Please_enter_last_name,
    }),

  gender: Joi.number()
    .valid(1, 2) // Allow only 1 and 2 as valid values
    .required()
    .messages({
      "number.base": currentLang?.ValidationSchema?.Please_select_gender,
      "any.only": currentLang?.ValidationSchema?.Please_select_gender,
      "any.required": currentLang?.ValidationSchema?.Please_select_gender,
      "string.empty": currentLang?.ValidationSchema?.Please_select_gender,
    }),

  address1: Joi.string().trim().min(1).max(100).required().messages({
    "string.base": currentLang?.ValidationSchema?.Address_Line1_must_string,
    "string.min": "Address Line 1 must be at least {#limit} characters long.",
    "string.max": "Address Line 1 must be at most {#limit} characters long.",
    "any.required": currentLang?.ValidationSchema?.Please_enter_address1,
    "string.empty": currentLang?.ValidationSchema?.Please_enter_address1,
  }),

  address2: Joi.string()
    .trim()
    // .max(100)
    .allow("")
    .messages({
      // 'string.base': 'Address Line 2 must be a string.',
      // 'string.max': 'Address Line 2 must be at most {#limit} characters long.',
    }),

  city: Joi.string().trim().min(1).max(50).required().messages({
    "string.base": currentLang?.ValidationSchema?.City_must_be_a_string,
    "string.min": "City must be at least {#limit} characters long.",
    "string.max": "City must be at most {#limit} characters long.",
    "any.required": currentLang?.ValidationSchema?.Please_enter_city,
    "string.empty": currentLang?.ValidationSchema?.Please_enter_city,
  }),


  stateName: Joi.number()
    //  .valid(1, 2) // Allow only 1 and 2 as valid values
    .required()
    .messages({
      "number.base": currentLang?.ValidationSchema?.Please_select_state,
      "any.only": currentLang?.ValidationSchema?.Please_select_state,
      "any.required": currentLang?.ValidationSchema?.Please_select_state,
      "string.empty": currentLang?.ValidationSchema?.Please_select_state,
    }),

  zip: Joi.string()
    .pattern(new RegExp("^[0-9]{5}(?:-[0-9]{4})?$"))
    .required()
    .messages({
      "string.pattern.base": currentLang?.ValidationSchema?.ZipCode_Format,
      "any.required": currentLang?.ValidationSchema?.Please_enter_ZIP,
      "string.empty": currentLang?.ValidationSchema?.Please_enter_ZIP,
    }),

  cellPhone: Joi.string()
    .pattern(new RegExp("^\\(\\d{3}\\) \\d{3}-\\d{4}$"))
    .required()
    .messages({
      "string.pattern.base": currentLang?.ValidationSchema?.Please_enter_valid_phone_number,

      "any.required": currentLang?.ValidationSchema?.Please_enter_phone_number,
      "string.empty": currentLang?.ValidationSchema?.Please_enter_phone_number,
    }),

  // isTeamsConditionVerified: Joi.boolean().valid(true).required().messages({
  //   "any.only": "You must agree to the terms of service.",
  //   "any.required": "You must agree to the terms of service.",
  // }),

  // isSubscribeMail: Joi.number()
  // .valid(1)
  // .required()
  // .messages({
  //   "any.only": "You must be above 18 years.",
  //   "any.required": "You must be above 18 years.",
  // }),

}).unknown(true);

module.exports = myAccountSchema;
